import type { IdTokenResult } from "firebase/auth";
import { appConfig } from "../config/appConfig";
import type { PurchasesSession } from "../services/purchasesService";

export const createDefaultPurchasesSession = (
  overrides: Partial<PurchasesSession> = {}
): PurchasesSession => ({
  configured: false,
  apiKeyPresent: Boolean(appConfig.purchases.publicApiKey.trim()),
  currentAppUserId: null,
  revenueCatAppUserId: null,
  isAnonymous: true,
  activeEntitlements: [],
  customerInfo: null,
  error: null,
  ...overrides,
});

export const normalizeClaims = (tokenResult?: IdTokenResult): Record<string, unknown> => {
  return (tokenResult?.claims || {}) as Record<string, unknown>;
};
